export const EMPTY_STRING: string = '';

export const LOCAL_STORAGE = {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    DISPATCHER_URL: 'DISPATCHER_URL'
};